import { render, staticRenderFns } from "./TransferEvent.vue?vue&type=template&id=c8df0728"
import script from "./TransferEvent.vue?vue&type=script&lang=js"
export * from "./TransferEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports